import { createContext } from "react";

import { ChangeConditionHelper } from "./ChangeConditionHelper.ts";

// Empty object is provided as default context as unable to create a class without a RootStore
// This will result in the app or tests breaking if a context value isn't provided

export const ChangeConditionContext = createContext<ChangeConditionHelper>(
  {} as ChangeConditionHelper
);
